export const dataStoreHasTags = (entityData) => {
  if (
    entityData?.tags?.length > 0 ||
    entityData?.mongo_atlas_data?.project_tags?.length > 0 ||
    entityData?.azure_sql_database_data?.resource_tags?.length > 0 ||
    entityData?.azure_storage_account_data?.resource_tags?.length > 0 ||
    entityData?.azure_blob_container_data?.resource_tags?.length > 0 ||
    entityData?.azure_file_share_data?.resource_tags?.length > 0 ||
    entityData?.azure_queue_data?.resource_tags?.length > 0 ||
    entityData?.azure_table_data?.resource_tags?.length > 0 ||
    entityData?.starburst_snowflake_catalog_data?.tags?.length > 0 ||
    entityData?.sentra_data?.tags?.length > 0
  ) {
    return true;
  } else {
    return false;
  }
};
export const dataStoreHasHistory = (entityData) => {
  if (
    entityData?.aws_data?.creation_date ||
    entityData?.mongo_atlas_data?.create_date ||
    entityData?.snowflake_data?.creation_time ||
    entityData?.azure_sql_database_data?.creation_date ||
    entityData?.azure_storage_account_data?.creation_date ||
    entityData?.azure_blob_container_data?.creation_date ||
    entityData?.azure_file_share_data?.creation_date ||
    entityData?.azure_queue_data?.creation_date ||
    entityData?.azure_table_data?.creation_date ||
    entityData?.sentra_data?.creation_date ||
    entityData?.checkmarx_data?.last_scan ||
    entityData?.checkmarx_data?.created_at ||
    entityData?.checkmarx_data?.updated_at ||
    entityData?.github_data?.created_at ||
    entityData?.github_data?.updated_at
  ) {
    return true;
  } else {
    return false;
  }
};

export const dataStoreHasActivity = (entityData) => {
  return entityData?.aws_data?.access_logs?.length > 0;
};
